import React from 'react';

const TicketSelectOption = ({ label, description, disabled, onClick, status, statusTone, style, ...props }) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    style={{ display: 'grid', gap: '0.2rem', minHeight: '38px', padding: '0.5rem 0.6rem', borderRadius: '6px', border: '1px solid transparent', backgroundColor: 'transparent', color: 'var(--text-primary)', cursor: disabled ? 'not-allowed' : 'pointer', textAlign: 'left', ...style }}
    {...props}
  >
    <span style={{ fontWeight: 900, fontSize: '0.82rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
    {description && <span style={{ color: 'var(--text-muted)', fontSize: '0.7rem' }}>{description}</span>}
    {status && <span className={`tickets-status-pill tickets-status-${statusTone}`} style={{ justifySelf: 'start', maxWidth: 'none' }}>{status}</span>}
  </button>
);

export default TicketSelectOption;
